<template>
  <v-container fluid grid-list-xs class="pa-3">
    <v-layout>
      <v-flex xs4>
        <v-card dark style="height:100%;">
          <v-card-title style="background:rgba(0,0,0,0.13)">Unallocated</v-card-title>
          <v-list class="d-block transparent" style="height:100%;">
            <draggable
              :component-data="{ props: { dense: true } }"
              v-bind="{ group: question.id }"
              style="height:100%;"
              v-model="unallocatedAnswers"
            >
              <v-list-item
                v-for="answer in unallocatedAnswers"
                :key="answer.id"
                style="border-bottom: 1px solid rgba(255, 255, 255, 0.18)"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ answer.label }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </draggable>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs4>
        <v-card dark color="red" style="height:100%;">
          <v-card-title style="background:rgba(0,0,0,0.13)">Red</v-card-title>
          <v-list class="d-block transparent" style="height:100%;">
            <draggable
              :component-data="{ props: { dense: true } }"
              v-bind="{ group: question.id }"
              style="height:100%;"
              v-model="redAnswers"
            >
              <v-list-item
                v-for="answer in redAnswers"
                :key="answer.id"
                style="border-bottom: 1px solid rgba(255, 255, 255, 0.18)"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ answer.label }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </draggable>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs4>
        <v-card dark color="orange" style="height:100%;">
          <v-card-title style="background:rgba(0,0,0,0.13)">Amber</v-card-title>
          <v-list class="d-block transparent" style="height:100%;">
            <draggable
              :component-data="{ props: { dense: true } }"
              v-bind="{ group: question.id }"
              style="height:100%;"
              v-model="amberAnswers"
            >
              <v-list-item
                v-for="answer in amberAnswers"
                :key="answer.id"
                style="border-bottom: 1px solid rgba(255, 255, 255, 0.18)"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ answer.label }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </draggable>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs4>
        <v-card dark color="green" style="height:100%;">
          <v-card-title style="background:rgba(0,0,0,0.13)">Green</v-card-title>
          <v-list class="d-block transparent" style="height:100%;">
            <draggable
              :component-data="{ props: { dense: true } }"
              v-bind="{ group: question.id }"
              style="height:100%;"
              v-model="greenAnswers"
            >
              <v-list-item
                v-for="answer in greenAnswers"
                :key="answer.id"
                style="border-bottom: 1px solid rgba(255, 255, 255, 0.18)"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ answer.label }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </draggable>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import _ from 'lodash';
import draggable from 'vuedraggable';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    draggable
  },
  name: 'answer-colour-picker',
  props: ['question'],
  computed: {
    ...mapGetters(['SelectedFunder']),
    colours() {
      return _.filter(this.SelectedFunder.colours, { question_id: this.question.id });
    },
    mergedAnswers() {
      return _.map(this.question.answers, this.mergeColours);
    },
    redAnswers: {
      get() {
        return _.filter(this.mergedAnswers, { colour: 'red', enabled: true });
      },
      set(value) {
        const changes = _.difference(value, _.filter(this.mergedAnswers, { colour: 'red', enabled: true }));
        if (changes.length === 1) {
          this.updateColour({ id: changes[0].colour_id, colour: 'red' });
        }
      }
    },
    amberAnswers: {
      get() {
        return _.filter(this.mergedAnswers, { colour: 'amber', enabled: true });
      },
      set(value) {
        const changes = _.difference(value, _.filter(this.mergedAnswers, { colour: 'amber', enabled: true }));
        if (changes.length === 1) {
          this.updateColour({ id: changes[0].colour_id, colour: 'amber' });
        }
      }
    },
    greenAnswers: {
      get() {
        return _.filter(this.mergedAnswers, { colour: 'green', enabled: true });
      },
      set(value) {
        const changes = _.difference(value, _.filter(this.mergedAnswers, { colour: 'green', enabled: true }));
        if (changes.length === 1) {
          this.updateColour({ id: changes[0].colour_id, colour: 'green' });
        }
      }
    },
    unallocatedAnswers: {
      get() {
        return _.filter(this.mergedAnswers, { colour: null, enabled: true });
      },
      set(value) {
        const changes = _.difference(value, _.filter(this.mergedAnswers, { colour: null, enabled: true }));
        if (changes.length === 1) {
          this.updateColour({ id: changes[0].colour_id, colour: null });
        }
      }
    }
  },
  methods: {
    ...mapActions(['updateColour']),
    mergeColours(answer) {
      if (_.isUndefined(answer)) {
        return null;
      }
      const index = _.findIndex(this.colours, { answer_id: answer.id });
      const colour = this.colours[index];
      if (_.isUndefined(colour)) {
        return null;
      }
      answer.colour = colour.colour;
      answer.colour_id = colour.id;
      return answer;
    },
    diff(object, base) {
      function changes(object, base) {
        return _.transform(object, (result, value, key) => {
          if (!_.isEqual(value, base[key])) {
            result[key] = _.isObject(value) && _.isObject(base[key]) ? changes(value, base[key]) : value;
          }
        });
      }

      return changes(object, base);
    }
  }
};
</script>

<style lang="scss" scoped></style>
